const isSafariUserAgent = () => /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);

export default isSafariUserAgent;
